import { axiosInstancepy } from "./AxiosInstance";

// Fetch data based on selected filters
export async function getProviderGrpRecords({
  provider,
  providerGroup,
  cmsProvider,
  cmsProviderGroup,
  status = "All",
}) {
  const url = `GetCmProviderGrpRecords?providerGroup=${
    providerGroup || "All"
  }&Provider=${provider || "All"}&allignedProvider=${
    cmsProvider || "All"
  }&cmsProvider=${cmsProviderGroup || "All"}&status=${status}`;

  try {
    const response = await axiosInstancepy.get(url);
    return response.data; // return only the data part
  } catch (error) {
    console.error("Error fetching provider group records:", error);
    throw error; // rethrow if you need to handle it later
  }
}

// Fetch archived data based on selected filters
export async function getArchivedProviderGrpRecords({
  provider,
  providerGroup,
  cmsProvider,
  cmsProviderGroup,
}) {
  return getProviderGrpRecords({
    provider,
    providerGroup,
    cmsProvider,
    cmsProviderGroup,
    status: "Archived", // set status as 'Archived'
  });
}

export async function getFavouritesList() {
  const url = `getGroupRecords?ManageId=${sessionStorage.getItem("userName")}`;
  try {
    const response = await axiosInstancepy.get(url);
    return response.data; // return only the data part
  } catch (error) {
    console.error("Error fetching Favourites List : ", error);
    throw error; // rethrow if you need to handle it later
  }
}

export async function postHnProvGrpRounds(body) {
  return axiosInstancepy
    .post("/AddCmProviderGrpRecords", body)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error;
    });
}

export async function postFavouriteList(body) {
  return axiosInstancepy
    .post("/addCaseGroup", body)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error;
    });
}

export async function deleteFavouriteList(body) {
  return axiosInstancepy
    .delete("/DeleteGroupCase", { data: body })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error;
    });
}

export async function postGroupList(body) {
  return axiosInstancepy
    .post("/CaseGroupPatients", body)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error;
    });
}

export async function deleteFromFavList(body) {
  return axiosInstancepy
    .delete("/DeleteCaseGroupPatients", { data: body })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error;
    });
}
